import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import {
  Button,
  ButtonToolbar,
  Modal,
  Col,
} from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';

const EditarNotasDialog = ({
  inscripcionMateria,
  onConfirm,
  onValueChanges,
}) => {
  const color = 'form';
  const modalClass = 'modal-dialog--header';
  const {
    fechaInscripcion,
    nombreAlumno,
    apellidoAlumno,
    porcentajeAsistencia = 0,
    porcentajePP = 0,
  } = inscripcionMateria;
  const inscripcion = moment(fechaInscripcion);

  const customUI = ({ onClose }) => {
    const validate = (values) => {
      const attrs = values || {};
      if (attrs.porcentajeAsistencia < 0 || attrs.porcentajeAsistencia > 100) {
        return 'Debe ingresar un porcentaje válido(0-100)';
      }
      if (attrs.porcentajePP < 0 || attrs.porcentajePP > 100) {
        return 'Debe ingresar un porcentaje válido(0-100)';
      }

      return '';
    };

    let errors = {
      porcentajeAsistencia: '',
      porcentajePP: '',
    };

    const handleChange = (event) => {
      event.persist();
      const values = { [event.target.name]: +event.currentTarget.value };
      errors = { ...errors, [event.target.name]: validate(values) };

      onValueChanges(event.target.name, +event.currentTarget.value);

      document.getElementById('lblPorcentajeAsistencia').textContent = errors.porcentajeAsistencia;

      document.getElementById('lblPorcentajePP').textContent = errors.porcentajePP;
    };

    return (
      <div>
        <Modal
          isOpen
          modalClassName="modal ltr-support"
          className={`modal-dialog--${color} ${modalClass} theme-dark`}
        >
          <div className="modal__header">
            <h4 className="text-modal  modal__title">Editar Asistencia / Notas</h4>
          </div>
          <div className="modal__body">

            <div className="form">
              <Col lx={12} md={12} lg={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label">Alumno</span>
                  <div className="form__form-group-field">
                    <input type="text" value={`${nombreAlumno} ${apellidoAlumno}`} disabled />
                  </div>
                </div>
              </Col>
              <Col lx={12} md={6} lg={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label">Fecha de inscripcion</span>
                  <div className="form__form-group-field">
                    <input type="text" value={inscripcion.format('DD/MM/YYYY')} disabled />
                  </div>
                </div>
              </Col>
              <Col lx={12} md={6} lg={6} />
              <Col lx={12} md={6} lg={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Porcentaje de asistencia</span>
                  <div className="form__form-group-field">
                    <input
                      noValidate
                      name="porcentajeAsistencia"
                      type="number"
                      min="0"
                      max="100"
                      placeholder="Porcentaje de asistencia"
                      autoComplete="false"
                      defaultValue={porcentajeAsistencia}
                      onChange={handleChange}
                    />
                    <span id="lblPorcentajeAsistencia" className="form__form-group-error">.</span>
                  </div>
                </div>
              </Col>
              <Col lx={12} md={6} lg={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Porcentaje PP</span>
                  <div className="form__form-group-field">
                    <input
                      name="porcentajePP"
                      type="number"
                      min="0"
                      max="100"
                      required
                      placeholder="Porcentaje PP"
                      autoComplete="false"
                      defaultValue={porcentajePP}
                      onChange={handleChange}
                    />
                    <span id="lblPorcentajePP" className="form__form-group-error">.</span>
                  </div>
                </div>
              </Col>
            </div>
          </div>
          <ButtonToolbar className="modal__footer">
            {!errors.porcentajePP
              && (
                <Button
                  className="btn btn-primary"
                  color={color}
                  onClick={() => {
                    onConfirm();
                    onClose();
                  }}
                >
                  Guardar
                </Button>
              )
            }
            <Button className="btn btn-secondary" onClick={onClose}>Cancelar</Button>
          </ButtonToolbar>
        </Modal>
      </div>
    );
  };

  customUI.propTypes = {
    onClose: PropTypes.func.isRequired,
  };

  confirmAlert({
    customUI,
  });
};

EditarNotasDialog.propTypes = {
  inscripcionMateria: PropTypes.shape({}).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onValueChanges: PropTypes.func.isRequired,
};

export default EditarNotasDialog;
